var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userCenter"},[_c('userInfo',{attrs:{"users":_vm.users,"id":"userInfo"}}),_c('orderInfo',{attrs:{"id":"orderInfo"}}),_c('consumptionHistory',{attrs:{"table_height":_vm.table_height - 125}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }